<template>
  <div v-if="!isEmpty(userCampaigns)">
    <b-card no-body>
      <b-card-header class="pb-50" />
      <b-card-body>
        <b-row>
          <b-col
            cols="12"
            md="3"
            class="mb-0"
          >
            <label>活動</label>
            <v-select
              v-model="filter.cid"
              dir="ltr"
              :options="userCampaigns"
              :reduce="userCampaigns => userCampaigns.cid"
              label="campaignName"
              :clearable="false"
              class="w-100 per-page-selector d-inline-block"
              @input="fetchCampaignRecords"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-0"
          >
            <div>
              <label for="datepicker">選擇日期</label>
              <b-form-datepicker
                id="datepicker"
                v-model="filter.dates.start"
                class="mb-1"
                @input="dateChange"
              />
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          />
          <!-- Search -->
          <b-col
            v-if="false"
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>
      <b-table
        ref="refUserListTable"
        class="position-relative"
        thead-class="text-nowrap"
        :items="records"
        responsive
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.user.claims.photoURL"
                :text="avatarText(data.item.user.displayName)"
                :to="{ name: '', params: { id: data.item.uid } }"
              />
            </template>
            <b-link
              :to="{ name: '', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.user.displayName }}
            </b-link>
            <small
              class="text-muted text-nowrap"
            >{{ data.item.user.claims.displayName }}</small>
          </b-media>
        </template>

        <!-- Column: Phone Number -->
        <template #cell(phoneNumber)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.user.phoneNumber }}</span>
          </div>
        </template>

        <!-- Column: Check in Date -->
        <template #cell(createAt)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.createAt | moment("YYYY/MM/DD HH:mm:ss") }}</span>
          </div>
        </template>

        <!-- Column: Campaign Name -->
        <template #cell(campaignName)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.campaign.campaignName }}</span>
          </div>
        </template>

        <!-- Column: Provider -->
        <template #cell(provider)="data">
          <div class="text-nowrap">
            <span class="align-item-center text-capitalize">{{ data.item.user.claims.provider }}</span>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="recordsCount"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BLink,
  BPagination, BFormDatepicker,
} from 'bootstrap-vue'
import store from '@/store'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BFormDatepicker,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BPagination,
    vSelect,
  },
  data() {
    return {
      selectedMonth: this.$moment(),
      selectedDate: this.$moment().format('YYYY-MM-DD'),
      searchQuery: undefined,
      tableColumns: [
        { key: 'user', label: '姓名', sortable: false },
        { key: 'phoneNumber', label: '連絡電話', sortable: false },
        { key: 'campaignName', label: '活動名稱', sortable: false },
        { key: 'createAt', label: '登錄日期', sortable: true },
        { key: 'provider', label: '登入方式', sortable: false },
      ],
      sortBy: 'createAt',
      isSortDirDesc: true,
      perPage: 100,
      currentPage: 1,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      avatarText,
      filter: {
        uid: '',
        cid: '',
        dates: {
          start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0),
          end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 0),
        },
      },
    }
  },
  computed: {
    ...mapGetters(['records', 'recordsCount', 'userCampaigns', 'user']),
  },
  async mounted() {
    this.filter.cuid = this.user.uid
    this.filter.cid = (this.userCampaigns[0] && this.userCampaigns[0].cid) ? this.userCampaigns[0].cid : ''

    await this.fetchCampaignRecords()
  },
  methods: {
    dateChange() {
      this.filter.dates.start = new Date(this.filter.dates.start)
      this.filter.dates.end = new Date(this.filter.dates.start)
      this.filter.dates.end.setDate(this.filter.dates.end.getDate() + 1)
      this.fetchCampaignRecords()
    },
    fetchCampaignRecords() {
      return new Promise(resolve => {
        if (this.filter.cid && this.filter.cuid) {
          store.dispatch('fetchCampaignRecords', this.filter)
          resolve()
        } else {
          resolve()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
</style>

<style>
  .mx-input:hover,
  .mx-input:focus {
    border-color: #B9524F;
  }
  .mx-input {
    height: 36px;
  }
  .mx-datepicker-main .mx-calendar-content .cell.active {
    background-color: #B9524F;
  }
  .mx-datepicker-main .mx-calendar-content .cell:hover {
    background-color: #fff5f5
  }

  .mx-datepicker-main .mx-btn:hover {
    border-color:#B9524F;
    color: #B9524F;
  }
  .vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 41px);
  }

  .vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }

  .vs__search {
    position: absolute;
  }

  .vs--open .vs__search {
    position: static;
  }

  .vs__dropdown-option {
    white-space: normal;
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
